import React from 'react'

function TopArtistsItem( { userPath, userProfileThumb, userName, amount } ) {
    return (
        <div className="marketMoveStyle">
           <span>
           <a href={ userPath }><img className="MarketMoveUserThumb" src={userProfileThumb} alt={ userName }/></a>
            <a className="MarketMoveUserName" href={ userPath } className="username"><b>{ userName } </b></a>
            </span>
            <p><small className="countNumber">${ amount } </small></p> 
        </div>
    )
}

export default TopArtistsItem
